import React, { useEffect, useState } from "react";

export default function FlashMessageContainer({ flashMessage }) {
  const [visibleClassNames, setVisibleClassNames] = useState("not-visible");
  useEffect(() => {
    if (flashMessage.message !== "") {
      setVisibleClassNames("visible fade-out");
      setTimeout(() => {
        setVisibleClassNames("not-visible");
      }, 6000);
    }
  }, [flashMessage]);

  return (
    <div className="flash-message-container">
      <div className={"flash-message-bubble " + visibleClassNames}>
        {flashMessage.message}
      </div>
    </div>
  );
}
